import { Img } from 'openimg/react';
import Carousel from './ui/carousel';
import { CarouselItem } from '@repo/ui/components/carousel';
import { ILandingPage } from '~/types/types';
import { hostName } from '~/utils/format';
import { Link } from 'react-router';

function MainBanner({ listBanner = [] }: {
  listBanner: ILandingPage['config']['hero']
}) {
  return (
    <Carousel
      className="w-full"
      userOptions={{ delay: 5000, playOnInit: true }}
      opts={{
        loop: true,
      }}
    >
      {listBanner.map((image, idx) => {
        return (
          <CarouselItem
            className="relative p-0"
            key={idx}
          >
            <Link
              to={image.link}
              className="relative min-h-[328px]  md:h-[600px]  block w-full"
            >
              {image.images.map((i) => {
                return (
                  <Img
                    key={i.id}
                    src={hostName(i.path)}
                    fit="cover"
                    width={5760}
                    height={2400}
                    params={{
                      "black-white": "true",
                      blur: "5",
                      quality: "100",
                    }}
                    alt="Kland"
                  />
                );
              })}
            </Link>
          </CarouselItem>
        );
      })}
    </Carousel>
  );
}

export default MainBanner
